// extracted by mini-css-extract-plugin
module.exports = {"ToUpArrow":"style_ToUpArrow__10UL2","Arrow":"style_Arrow__3MiMF"};